<template>
  <div id="app">
    
    <router-view></router-view>
	
  </div>
</template>

<script>
  export default {
    name: 'app',
    mounted(){
    }
  }
</script>

<style  lang="css" >
.banner {
    height: 79px;
    background-color: #2a0669
  }
  .tabs {
    background-color: transparent;
  }
  .banner_right_content {
    width: 50vw
  }
 .banner_tools {
    height: 70px;
    background-color: transparent;
    padding-top: 18px
  }
  .banner_tools .mu-buttom-item {
    color: #fff
  }
.sub-header i.mu-icon,.setting i.mu-icon{
	 font-size:16px;
}
.list_item .mu-item-title,.list_item .mu-item {
    color: #fff!important;
  }
  .user_content .mu-card-title,
  .user_content .mu-card-sub-title {
    color: #fff
  }
.flooter {
text-align: center;
background-color: #2a0669;
color: #fff;
padding: 10px;
}
</style>



// WEBPACK FOOTER //
// App.vue?a21dc586